<template>
  <main-layout>
    <v-content>
      <v-container>
        <config-tabs />
        <router-view></router-view>
      </v-container>
    </v-content>
  </main-layout>
</template>
<script>
import ConfigTabs from "./tabs";

export default {
  components: { ConfigTabs },
};
</script>
